import styled from "styled-components";

export const StyledWrapper = styled.div`
  .SingleDatePickerInput__withBorder {
    border: 1px solid #bdc2ca;
  }
  .DateInput_input {
    height: 38px;
  }
`;

export const InputHeader = styled.div`
  margin-bottom: 10px;
  color: #63636d;
  font-size: 14px;
  font-weight: 400;
`;

export const Container = styled.div`
  margin: 0;
`;

export const Validation = styled.div`
  width: 100%;
  color: grey;
  font-size: 12px;
  line-height: auto;
  margin: 0;
  padding-left: 5px;
  margin-bottom: 1%;
  overflow: visible;
  white-space: wrap;
`;
